<template>
  <div class="m-component-header">
    <!-- ★ 核心渐变层：根据黑白 Logo 切换对应的矩形层 -->
    <div 
      class="gradient-layer" 
      :class="logoColor === 'black' ? 'gradient-light' : 'gradient-dark'"
    ></div>

    <!-- Logo 内容层（确保 z-index 在渐变层之上） -->
    <div class="logo-wrapper">
      <img 
        v-if="logoColor === 'black'" 
        src="@/assets/mobile/home/logo_black.png" 
        alt="Logo" 
        class="logo" 
        @click="goHome"
      >
      <img 
        v-else 
        src="@/assets/mobile/home/logo.png" 
        alt="Logo" 
        class="logo" 
        @click="goHome"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: {
    logoColor: {
      type: String,
      default: 'white' // white 对应黑底白标，black 对应白底黑标
    }
  },
  methods: {
    goHome() {
      this.$router.push('/m')
    }
  }
}
</script>

<style scoped>
/* 外层容器 */
.m-component-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 92rem;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  pointer-events: none;
  z-index: 1000;
  overflow: hidden;
}

/* 渐变背景层 */
.gradient-layer {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 92px;
  pointer-events: none;
  z-index: 0;
}

/* ★ 白色 Logo 专属渐变 (黑色渐变底，透明度降低约50% + 模糊) */
.gradient-dark {
 background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(217, 217, 217, 0) 100%);
 backdrop-filter: blur(0px);
  /* 模糊效果，可根据需要调整数值 */
  height: 92px;
}

/* 黑色 Logo 专属渐变 (白色到透明，可选择性添加模糊，但本例未要求) */
.gradient-light {
  background: linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(217, 217, 217, 0) 100%);
  /* 若需要也可添加模糊，但根据需求暂不添加 */
  height: 92px;
}

/* Logo 包装层 */
.logo-wrapper {
  position: relative;
  z-index: 0;
  width: 100%;
  text-align: center;
}

.logo {
  display: block;
  width: 100%;
  height: auto;
  pointer-events: auto;
  cursor: pointer;
  padding-top: 5rem;
}
</style>